<script setup lang="ts">
import { computed } from "vue";
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";

const props = defineProps<{
  kind?: "standard" | "warning" | "highlight" | "denied";
}>();

const icon = computed(() => {
  if (props.kind === "highlight") return "check-curvy-small";
  if (props.kind === "warning") return "warning-hexagon";
  if (props.kind === "denied") return "cross-filled";
  return "check";
});

const classList = computed(() => {
  if (props.kind === "highlight") return "list-item--highlight";
  if (props.kind === "warning") return "list-item--warning";
  if (props.kind === "denied") return "list-item--denied";
  return "";
});
</script>

<template>
  <li class="list-item" :class="classList">
    <UseSvg class="list-item__icon" :icon="icon" />
    <span><slot /></span>
  </li>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings";
@import "frontend/init/jiffy/mixin";

.list-item {
  $this: &;

  display: flex;
  align-items: center;
  color: $black-light;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;

  :deep(a) {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 3px;

    &:focus,
    &:hover {
      color: $blue;
    }
  }

  &--warning {
    #{$this}__icon {
      color: $tahiti-gold;
    }
  }

  &--highlight {
    #{$this}__icon {
      color: $primary-light;
    }
  }

  &--denied {
    #{$this}__icon {
      color: $red-light;
    }
  }

  &__icon {
    width: 20px;
    height: 20px;
    color: $primary-light;
    margin-right: 8px;
    margin-bottom: auto;
  }
}
</style>
